import { useEffect, useRef } from 'react';

export const usePrevious = (value, initial) => {
  const ref = useRef(initial);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
